module.exports = __webpack_public_path__ + "fonts/weathericons-regular-webfont.8cac70eb.woff";